// 判断是否为移动设备
export const isMobileDevice = () => {
    return (
        typeof window.orientation !== 'undefined' ||
        navigator.userAgent.indexOf('Mobile') !== -1
    );
};
